import store from "@/store";
import roles from "@/plugins/roles";

export const checkRole = strRoleName => {
  let index;
  let roleIndex;
  const role = store.getters.role;


  roles.map((item) => item.role === strRoleName && (index = item.id));
  roles.map((item) => item.role === role && (roleIndex = item.id));

  return roleIndex >= index ? true : false;
};
